import { useTranslation } from "react-i18next";

const NewInputGenericReadOnly = ({ handleChange, values, errors, placeholderVal, field, max_length, moduleText, occupation = 6, css_class}) => {
  const { t } = useTranslation();

  return (
    <div className={`col-md-${occupation}`}>
      <label htmlFor={field} className="form-label tit-view">
      {t(`${moduleText}.short.${field}`)}
      </label>
      <div className="control">
        <input
          autoComplete="off"
          
          className={`form-control txt-view txt-read-only ${errors[field] && "border border-danger"}`}
          type="text"
          name={field}
          id={field}
          onChange={(event) => handleChange(event, field)}
          value={values[field] || ""}
          required
          maxLength={max_length}
          placeholder={placeholderVal ? t(`${moduleText}.short.${field}`) : null}
          readOnly
        />
        {values[field] && (
          <span className="charLeft">
            {values[field].length}/{max_length} {t("label.characters")}
          </span>
        )}
        {errors[field] && <pre> <p className="help text-danger">{errors[field]}</p> </pre>}
      </div>
    </div>
  )
}

export default NewInputGenericReadOnly

